import { load, save, remove } from 'data/browserStorage';
import { LOCAL_STORAGE } from 'data/browserStorage/constants';

import { MAX_HISTORY_ENTRIES } from './constants';
import { resetSearchStore } from './store/actions';

export const SEARCH_HISTORY_KEY_PREFIX = 'search_history_';

function storageKey(rootActivityId) {
  return `${SEARCH_HISTORY_KEY_PREFIX}${rootActivityId}`;
}

export function loadHistory(rootActivityId) {
  try {
    const raw = load(storageKey(rootActivityId), LOCAL_STORAGE);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(0, MAX_HISTORY_ENTRIES) : [];
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('loadHistory failed:', e);
    return [];
  }
}

export function saveHistory(rootActivityId, entries) {
  try {
    const trimmed = (entries || []).slice(0, MAX_HISTORY_ENTRIES);
    save(storageKey(rootActivityId), JSON.stringify(trimmed), LOCAL_STORAGE);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('saveHistory failed:', e);
  }
}

export function addEntry(rootActivityId, entry) {
  const entries = loadHistory(rootActivityId);
  const filtered = entries.filter(
    (h) => h.text.toLowerCase() !== entry.text.toLowerCase()
  );
  filtered.unshift(entry);
  const trimmed = filtered.slice(0, MAX_HISTORY_ENTRIES);
  saveHistory(rootActivityId, trimmed);
  return trimmed;
}

export function removeEntry(rootActivityId, text) {
  const entries = loadHistory(rootActivityId);
  const filtered = entries.filter(
    (h) => h.text.toLowerCase() !== text.toLowerCase()
  );
  saveHistory(rootActivityId, filtered);
  return filtered;
}

export function clearAllHistory(rootActivityId) {
  try {
    remove(storageKey(rootActivityId), LOCAL_STORAGE);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('clearAllHistory failed:', e);
  }
}

export function clearAllSearchHistory(dispatch) {
  try {
    const storage = window.localStorage;
    const keysToRemove = [];
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i);
      if (key && key.indexOf(SEARCH_HISTORY_KEY_PREFIX) === 0) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => remove(key, LOCAL_STORAGE));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('clearAllSearchHistory failed:', e);
  }

  if (typeof dispatch === 'function') {
    try {
      dispatch(resetSearchStore());
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('clearAllSearchHistory: redux reset failed:', e);
    }
  }
}
